var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "v-loading",
    },
    [
      _vm.hasMask ? _c("div", { staticClass: "v-loading__mask" }) : _vm._e(),
      _c("div", { staticClass: "v-loading__wrapper" }, [
        _c(
          "div",
          { class: ["v-loading__dots", `v-loading__dots--${_vm.size}`] },
          [
            _c("div", {
              staticClass: "v-loading__dot__item",
              style: _vm.dotStyle,
            }),
            _c("div", {
              staticClass: "v-loading__dot__item",
              style: _vm.dotStyle,
            }),
            _c("div", {
              staticClass: "v-loading__dot__item",
              style: _vm.dotStyle,
            }),
            _c("div", {
              staticClass: "v-loading__dot__item",
              style: _vm.dotStyle,
            }),
          ]
        ),
        _vm.text || _vm.$slots.default
          ? _c(
              "div",
              { staticClass: "v-loading__text" },
              [
                _vm._t("default", function () {
                  return [_vm._v(_vm._s(_vm.text))]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }